import React, { useEffect } from "react";
import classNames from 'classnames';
import { Alert } from "@/types/alert";
import { Container, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from '@mui/icons-material/Warning';

import styles from "./BannerAlert.module.css";

export interface BannerAlertProps {
  alert: Alert;
  className?: string;
  onDismiss: (id: string | number) => void;
}

export function BannerAlert(props: BannerAlertProps) {
  const { alert, className, onDismiss, } = props;

  const {
    id,
    type,
    message,
    title,
    dismissible = true,
    autoHide = 5000,
  } = alert;

  useEffect(() => {
    if (autoHide && autoHide > 0) {
      const timer = setTimeout(() => onDismiss(alert.id), autoHide);
      return () => clearTimeout(timer);
    }
  }, [id, autoHide, onDismiss]);

  const handleDismiss = () => {
    onDismiss(id);
  };

  const icon = () => {
    switch (type) {
      case "warning":
        return <WarningIcon sx={{ color: "black" }} />
      default:
        return;
    }
  }

  return (
    <Container maxWidth={false} sx={{ backgroundColor: 'orange', position: 'relative', p: 1, display: 'flex', gap: '1rem', alignItems: "center" }} className={classNames(className)} role="alert">
      {type === "warning" && icon()}
      <div className={styles.BannerAlert}>
        {title && (
          <Typography fontWeight={700} fontSize={'16px'} color={"black"}>{title}:</Typography>
        )}
        <Typography color={"black"} fontSize={'16px'}>{message}</Typography>
      </div>

      {dismissible && (
        <IconButton
          aria-label="close"
          onClick={handleDismiss}
          size="small"
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "black"
          }}
        >
          <CloseIcon />
        </IconButton>
      )}
    </Container>
  );
};

export default BannerAlert;
